import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule, ServicesModule } from 'world-archery-lib';
import { Router, Scroll, RouteReuseStrategy, ActivationEnd, RoutesRecognized } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter, pairwise } from 'rxjs/operators';
import { CommonTranslateModule } from './common-page-components/transloco-module/common-translate-module.module';

import { HttpLoaderTranslateService, CustomTranspiler, CustomTranslationService } from './common-page-components/services/http-loader-translate.service';
import { TRANSLOCO_LOADER, TRANSLOCO_CONFIG, translocoConfig, TRANSLOCO_TRANSPILER, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { RouteAthleteReuseStrategy } from './athlete/utils/route-reuse';
import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    CommonTranslateModule,
    NgxGoogleAnalyticsModule.forRoot(environment.gtm_tracking_code),
    AppRoutingModule,
    CoreModule,
    ServicesModule,
    LazyLoadImageModule.forRoot({
      preset: intersectionObserverPreset // <-- tell LazyLoadImage that you want to use IntersectionObserver
    })
  ],

  exports: [
    CommonTranslateModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    router: Router,
    viewPort: ViewportScroller,
    break_point: BreakpointObserver,
  ) {
    router.events
      .pipe(
        filter((e) => {
          return e instanceof Scroll;
        }),
        // Pairwise router events for check changes in query parameters.
        pairwise()
      )
      .subscribe(([previous, next]) => {
        const isMatched = break_point.isMatched([
          Breakpoints.Tablet,
          Breakpoints.TabletPortrait,
          Breakpoints.Tablet,
          Breakpoints.Medium,
          Breakpoints.Small,
          Breakpoints.XSmall
        ]);
        next = next as Scroll;
        previous = previous as Scroll;
        const previousURL = previous.routerEvent.urlAfterRedirects.split('?')[0];
        const nextURL = next.routerEvent.urlAfterRedirects.split('?')[0];
        // If the url path is the same after split the parameters, we don't do scroll.
        const isSameURL = previousURL === nextURL;
        /*if (isMatched === true) {
          if (!next.routerEvent.url.includes('/athlete/')) {
            next.position ? viewPort.scrollToPosition(next.position) : undefined;
            next.anchor ? viewPort.scrollToAnchor(next.anchor) : undefined;
          }
        } else {
          if (!isSameURL) {
            viewPort.scrollToPosition([0, 0]);
          }

        }*/
      });
  }
}
